import {useOfferAgeRating} from '@/hooks/catalog';
import {Divider, Stack, Text} from '@eds-web/react';
import {useGlobalRatingLink} from './useGlobalRatingLink.hook';
import {Box} from '@panda/jsx';
import {css} from '@panda/css';
import {Skeleton} from '@/components/atoms';

// const defaultRating = {
// 	type: messages["epic.app.spend.rating.type"],
// 	body: messages["epic.app.spend.rating.body"],
// 	footer: messages["epic.app.spend.rating.footer"],
// };
// return defaultRating;

const containerStyle = css({
	border: '1.5px solid #FFFFFF26',
	borderRadius: '16px',
	padding: '15px',
	overflow: 'hidden',
	outlineStyle: 'solid',
	outlineOffset: '1px',
	transitionProperty: 'all',
	transitionTimingFunction: 'ease',
	transitionDuration: '200ms',
	outlineWidth: '0',

	_hover: {
		outlineOffset: '1.5px',
		outlineWidth: '1.5px',
		outlineColor: 'eds.palette.static.white'
		// transition: "transform 0.2s ease",
		// transform: "scale(1.01)",
	}
});

/**
 * TBD: fetch age rating based off cms
 */
export const AgeRating = () => {
	const {data, isLoading, error} = useOfferAgeRating();
	const ratingLink = useGlobalRatingLink(data?.ratingSystem);
	const ratingType = data?.__typename;
	const rating = ratingType === 'AgeRating' ? data : undefined;

	if (!rating) {
		return null;
	}

	if (isLoading || error) {
		return <Skeleton height="94px" width="328px" borderRadius="16px" />;
	}

	const jsx = (
		<Box className={containerStyle}>
			<Stack gap={16} direction="row" noWrap align="center">
				<img
					src={rating.ratingImage}
					alt={rating.ratingSystem}
					width={50}
					height={61}
					loading="lazy"
				/>
				<Stack gap={4}>
					<Text variant="uiSMBold">{rating.title}</Text>
					<Text variant="uiSM" color="secondary">
						{rating.contentDescriptors?.join(', ')}
					</Text>
					<Divider color="white" />
					<Text variant="uiSM" color="secondary">
						{rating.interactiveElements?.join(', ')}
					</Text>
				</Stack>
			</Stack>
		</Box>
	);

	if (!ratingLink) {
		return jsx;
	}

	return (
		<a
			href={ratingLink}
			aria-label={rating?.ratingSystem}
			rel="noopener noreferer"
			target="_blank"
			style={{textDecoration: 'none'}}>
			{jsx}
		</a>
	);
};
